const isLastInArray = (array: Array<any>, currentIndex: number): boolean => {
    return currentIndex === array.length - 1
}

export default isLastInArray